module.exports = __webpack_public_path__ + "static/media/40-2.8a0b974b.mp3";